import { distribService } from "../_services";
import moment from 'moment'
moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    distribNew: {
      list: [],
      status: status.INITIAL
    },

    distribPeriod: {
      list: [],
      status: status.INITIAL
    },

    today: moment().format('YYYY-MM-DD'),
    period: null,
    periodDistributed: null,
    selectedCaseType: null,
    selectedJudge: null, 
    selectedSort: 0
  },

  getters: {
    distribNew: ({ distribNew }) => distribNew.list,
    isDistribNew: ({ distribNew }) => distribNew.status == status.LOADED,

    distribPeriod: ({ distribPeriod }) => distribPeriod.list,
    isDistribPeriod: ({ distribPeriod }) => distribPeriod.status == status.LOADED,
  },
  mutations: {
    setDistribNew: ({ distribNew }, payload) => {
      distribNew.list = payload
    },
    setDistribNewStatus: ({ distribNew }, status) => {
      distribNew.status = status
    },
    filterDistribNew: (state, listIds) => {
      state.distribNew.list = state.distribNew.list.filter(item => !listIds.includes(item.id))
    },

    setDistribPeriod: ({ distribPeriod }, payload) => {
      distribPeriod.list = payload
    },
    setDistribPeriodStatus: ({ distribPeriod }, status) => {
      distribPeriod.status = status
    },

    setPeriod: (state, payload) => {
      state.period = payload
    },

    setPeriodDistributed: (state, payload) => {
      state.periodDistributed = payload
    },

    selectCaseType: (state, payload) => {
      state.selectedCaseType = payload
    },

    selectJudge: (state, payload) => {
      state.selectedJudge = payload
    },

    selectSort: (state, payload) => {
      state.selectedSort = payload
    },

  },
  actions: {
    refresh: ({ dispatch }) => {
      dispatch('LOAD_NEW')
    },

    LOAD_NEW: ({ commit }) => {
      // if (state.distribNew.status == status.INITIAL) {
        commit('setDistribNewStatus', status.LOADING)
        distribService.newListCase().then(data => {
          commit('setDistribNew', data)
          commit('setDistribNewStatus', status.LOADED)
        })
      // }
    },

    LOAD_PERIOD: ({ state, commit }) => {
      let start = state.periodDistributed ? state.periodDistributed.start : state.today
      let end = state.periodDistributed ? state.periodDistributed.end : state.today

      commit('setDistribPeriodStatus', status.LOADING)
      commit('setDistribPeriod', [])
      distribService.getDistribListCase(start, end).then(data => {
        commit('setDistribPeriod', data)
        commit('setDistribPeriodStatus', status.LOADED)
      })
    },

    LOAD_PERIOD_HISTORY: ({ state, commit }) => {
      let start = state.periodDistributed ? state.periodDistributed.start : state.today
      let end = state.periodDistributed ? state.periodDistributed.end : state.today

      commit('setDistribPeriodStatus', status.LOADING)
      commit('setDistribPeriod', [])
      distribService.distributionHistory(start, end).then(data => {
        commit('setDistribPeriod', data)
        commit('setDistribPeriodStatus', status.LOADED)
      })
    }

  }
}